function statusChipColor(status) {
  if (status === 'COMPLETED') return 'brandPrimary';
  if (status === 'FAILED') return 'critical';

  return 'info';
}

export default statusChipColor;
